const toCamelCase = (str) => {
  return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
};

export const convertToCamelCase = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertToCamelCase(item));
  } else if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((acc, key) => {
      const camelCaseKey = toCamelCase(key);
      acc[camelCaseKey] = convertToCamelCase(obj[key]);
      return acc;
    }, {});
  }
  return obj;
};

export const convertToSnakeCase = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertToSnakeCase(item));
  } else if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((acc, key) => {
      const snakeCaseKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();
      acc[snakeCaseKey] = convertToSnakeCase(obj[key]);
      return acc;
    }, {});
  }
  return obj;
}